import { ScoutingFollowedPage } from "@/pages/scouting/followed/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/scouting/followed")({
    component: ScoutingFollowedPage,
});
